/* Giotelli — cart drawer discount code via Cart API */
(function(){
  var GT_R=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
  var T=window.GT_T||function(k){return k;};
  (function () {
    var R = GT_R;
    function msg(form, text, ok) { var d = form.closest('.gt-cd__coupon'); var m = d && d.querySelector('[data-cd-cmsg]'); if (!m) return; m.textContent = text; m.hidden = !text; m.classList.toggle('is-ok', !!ok); }
    function current() { return fetch(R + 'cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }); }
    function update(codes) { return fetch(R + 'cart/update.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ discount: codes.join(',') }) }).then(function (r) { return r.json(); }); }
    function reloadDrawer() { return fetch(R + 'cart?view=drawer', { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (t) { var tmp = document.createElement('div'); tmp.innerHTML = t; var nd = tmp.querySelector('.gt-drawer'), od = document.querySelector('.gt-drawer'); if (nd && od) { if (od.classList.contains('is-open')) nd.classList.add('is-open'); od.replaceWith(nd); if (window.gtCdUpsell) { try { window.gtCdUpsell(); } catch (e) {} } } return current(); }).then(function (c) { document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = c.item_count; el.style.display = c.item_count ? '' : 'none'; }); var s = document.querySelector('[data-cart-subtotal]'); if (s) { var v = c.total_price / 100; s.textContent = (c.total_price % 100 === 0 ? v.toLocaleString('de-DE', { maximumFractionDigits: 0 }) : v.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 })) + '€'; } }).catch(function () { window.location.reload(); }); }
    function codesOf(c) { return ((c && c.discount_codes) || []).map(function (x) { return x; }); }
    document.addEventListener('submit', function (e) {
      var f = e.target.closest('[data-cd-coupon]'); if (!f) return;
      e.preventDefault(); e.stopImmediatePropagation();
      var code = (f.code.value || '').trim().toUpperCase(); if (!code) return;
      f.classList.add('is-busy'); msg(f, '');
      current().then(function (c) {
        var keep = codesOf(c).filter(function (x) { return x.applicable; }).map(function (x) { return x.code; });
        if (keep.indexOf(code) < 0) keep.push(code);
        return update(keep);
      }).then(function (c) {
        f.classList.remove('is-busy');
        var hit = codesOf(c).filter(function (x) { return x.code.toUpperCase() === code; })[0];
        if (!hit || !hit.applicable) {
          var st = codesOf(c).filter(function (x) { return x.applicable; }).map(function (x) { return x.code; });
          update(st);
          msg(f, T('code_invalid'), false); return;
        }
        msg(f, T('code_applied').replace('%c', code), true); f.code.value = '';
        setTimeout(reloadDrawer, 350);
      }).catch(function () { f.classList.remove('is-busy'); msg(f, T('code_error'), false); });
    }, true);
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-cd-code-rm]'); if (!b) return;
      e.preventDefault(); var rm = b.getAttribute('data-cd-code-rm');
      current().then(function (c) { return update(codesOf(c).map(function (x) { return x.code; }).filter(function (x) { return x !== rm; })); })
        .then(reloadDrawer);
    });
  })();

  /* ---------- Checkout button: locale/preview-safe ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-cd-checkout]'); if (!b) return;
    e.preventDefault(); e.stopPropagation();
    if (b.getAttribute('aria-busy') === 'true') return;
    b.setAttribute('aria-busy', 'true'); b.style.opacity = '.7';
    var url = b.getAttribute('data-checkout-url') || (GT_R + 'checkout');
    var q = window.location.search || '';
    var m = q.match(/[?&](preview_theme_id=\d+)/); if (m && url.indexOf('preview_theme_id') < 0) url += (url.indexOf('?') > -1 ? '&' : '?') + m[1];
    try { window.location.assign(url); } catch (err) { var f = b.closest('form'); if (f) f.submit(); }
    setTimeout(function () { b.removeAttribute('aria-busy'); b.style.opacity = ''; }, 6000);
  }, true);
})();
